import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, logout} from "../../../features/user";
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken, userLoggedIn} from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import ListCard from '../../widgets/ListCard';

export function MarketingList() {
    const [state, setState] = useState({ search: "" });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        checkValidToken(navigate, dispatch, false, true, "/start");
        userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch);
       // eslint-disable-next-line
    },[]);


    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    };

    return (
        <Frame headerWhite={true} showMenu={true} showNav={true}>
            <div className='main marketing-list'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    <Background >
                        <div className='right-main-inner'>
                            <ListCard title={"social_media"} items={[{name:"social_media_marketing"}, {name:"influencers_marketing"}, {name:"community_management"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"analytics_and_strategy"} items={[{name:"marketing_strategy"}, {name:"marketing_consulting"}, {name:"market_analysis"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"methods_and_techniques"} items={[{name:"advertisement"}, {name:"video_marketing"}, {name:"pr"}]}></ListCard>
                            <div className='mb40'></div>
                        </div>
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}